module.exports = __webpack_public_path__ + "static/media/sapc.d06a5ba3.png";